'use strict';

exports.__esModule = true;
exports.DisabledWrapper = exports.RadioLabel = exports.Radio = exports.Select = exports.DownTriangle = exports.Pencil = exports.CheckBoxes = exports.TextAreaInput = exports.Input = exports.sharedInputStyles = exports.sharedTagStyles = exports.HelpHint = exports.Label = exports.ErrorText = exports.Container = exports.Grid = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SvgIcon = require('../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputHeight = '2.5rem';
var placeholderColor = _styles2.default.grayLight;
var inputTextColor = _styles2.default.black;
var fieldLabelColor = _styles2.default.grayDark;
var errorHightlightColor = '#fbeded';

var bgColorFn = function bgColorFn(p) {
  return p.focused ? _styles2.default.white : p.error ? errorHightlightColor : _styles2.default.white;
};
var fontSizeFn = function fontSizeFn(p) {
  return p.size === 'large' ? _styles2.default.inputTextLg : _styles2.default.inputTextSm;
};
var fontWeightFn = function fontWeightFn(p) {
  return p.size === 'large' ? _styles2.default.fontWeightBold : _styles2.default.fontWeightNormal;
};
var lineHeightFn = function lineHeightFn(p) {
  return p.size === 'large' ? _styles2.default.inputLineHeightLg : _styles2.default.inputLineHeightSm;
};
var getRadioBorderColor = function getRadioBorderColor(p) {
  if (p.disabled) {
    return _styles.colors.disabledControlBorderColor;
  }

  return p.checked ? _styles.colors.brandPrimaryAccessible : _styles.colors.controlBorderColor;
};

var getRadioBackgroundColor = function getRadioBackgroundColor(p) {
  if (p.disabled && p.checked) {
    return _styles.colors.disabledSelectedControlColor;
  }
  if (p.disabled && !p.checked) {
    return _styles.colors.disabledDeselectedControlColor;
  }

  return p.checked ? _styles.colors.brandPrimaryAccessible : _styles.colors.white;
};

var Grid = _styledComponents2.default.div.withConfig({
  displayName: 'styled__Grid'
})(['display:flex;flex-wrap:wrap;']);
Grid.displayName = 'Field.Grid';
exports.Grid = Grid;
var Container = exports.Container = _styledComponents2.default.div.withConfig({
  displayName: 'styled__Container'
})(['display:flex;flex-direction:column;position:relative;width:', ';padding-right:', ';color:', ';font-size:1rem;line-height:1.5;', ' @media screen and (max-width:', '){width:', ';}@media screen and (max-width:', '){width:100%;}> header,> main,> footer{display:flex;flex-direction:column;justify-content:center;}> header{height:', ';min-height:2rem;}> main{min-height:', ';background-color:', ';}> main,> main input{', ' padding:0;margin:0;font-size:', ';font-weight:', ';line-height:', ';}> footer{width:100%;min-height:2rem;margin-top:0;margin-bottom:1rem;transition:border-color 0.3s;', '}'], function (p) {
  return p.cols / 12 * 100 + '%';
}, inputHeight, _styles2.default.gray, function (p) {
  return !p.allowOverflow && (0, _styledComponents.css)(['overflow:hidden;text-overflow:ellipsis;white-space:nowrap;']);
}, _styles2.default.screenMd, function (p) {
  return p.cols <= 6 ? '50%' : '100%';
}, _styles2.default.screenSm, function (p) {
  return p.hasHelpHint ? '100%' : '2rem';
}, function (p) {
  return p.rows ? '' : '4rem';
}, bgColorFn, function (p) {
  return !p.allowOverflow && (0, _styledComponents.css)(['overflow:hidden;text-overflow:ellipsis;white-space:nowrap;']);
}, fontSizeFn, fontWeightFn, lineHeightFn, function (p) {
  return p.focused || p.error ? '\n        border-top: 1px solid ' + (p.error ? _styles2.default.brandDanger : _styles2.default.brandPrimary) + ';\n      ' : '\n        border-top: 1px solid ' + _styles2.default.inputBorderColor + ';\n      ';
});

var ErrorText = exports.ErrorText = _styledComponents2.default.small.withConfig({
  displayName: 'styled__ErrorText'
})(['font-size:1.5rem;line-height:calc(2rem - 1px);font-weight:', ';color:', ';'], _styles2.default.fontWeightSemibold, _styles2.default.brandDanger);

var Label = exports.Label = _styledComponents2.default.label.withConfig({
  displayName: 'styled__Label'
})(['position:relative;margin-bottom:0;width:100%;color:', ';font-size:', ';font-weight:', ';text-transform:uppercase;white-space:normal;font-size:1.5rem;line-height:2rem;'], fieldLabelColor, _styles2.default.fontSizeSmall, _styles2.default.fontWeightSemibold);

var HelpHint = exports.HelpHint = (0, _styledComponents2.default)(_SvgIcon2.default).attrs({
  name: 'question-2'
}).withConfig({
  displayName: 'styled__HelpHint'
})(['position:absolute;display:inline-block;margin:auto;margin-left:0.5rem;height:2rem;svg{width:2rem;height:2rem;fill:', ';}'], _styles2.default.grayLight);

var sharedTagStyles = exports.sharedTagStyles = (0, _styledComponents.css)(['flex-grow:0;flex-shrink:0;margin-top:0.5rem;margin-bottom:0.5rem;margin-right:0.5rem;height:3rem;line-height:calc(3rem - 2px);']);

var sharedInputStyles = exports.sharedInputStyles = (0, _styledComponents.css)(['width:100%;min-height:4rem;margin:0;color:', ';background-color:transparent;font-size:', ';font-weight:', ';line-height:', ';cursor:', ';text-overflow:ellipsis;&:disabled{cursor:not-allowed;}&:hover:not(:focus):not(:disabled) + .hoverIcon{opacity:1;}&::placeholder{color:', ';opacity:1;transition:opacity 0.2s;}&:focus,&:focus + .pencil{outline:0;}'], inputTextColor, fontSizeFn, fontWeightFn, lineHeightFn, function (p) {
  return p.readOnly ? 'normal' : 'text';
}, placeholderColor);

var Input = exports.Input = _styledComponents2.default.input.withConfig({
  displayName: 'styled__Input'
})(['', ' border:0;overflow:hidden;white-space:nowrap;&:focus::placeholder{opacity:', ';}', ''], sharedInputStyles, function (p) {
  return +!p.readOnly;
}, function (p) {
  return p.readOnly && 'user-select: none;';
});

var TextAreaInput = exports.TextAreaInput = _styledComponents2.default.textarea.withConfig({
  displayName: 'styled__TextAreaInput'
})(['', ' transition:border-color 0.3s;&:focus::placeholder{opacity:', ';}', ' ', ''], sharedInputStyles, function (p) {
  return +!p.readOnly;
}, function (p) {
  return p.readOnly && 'user-select: none;';
}, function (p) {
  return p.focused || p.error ? '\n      border: 1px solid ' + (p.error ? _styles2.default.brandDanger : _styles2.default.brandPrimary) + ';\n      border-bottom: ' + (p.error ? 'none' : 'auto') + ';\n    ' : '\n      border: 1px solid ' + _styles2.default.inputBorderColor + ';\n    ';
});

var CheckBoxes = exports.CheckBoxes = _styledComponents2.default.div.withConfig({
  displayName: 'styled__CheckBoxes'
})(['display:flex;flex-direction:row;background-color:', ';min-height:4rem;align-items:center;user-select:none;> div{display:flex;align-items:center;align-content:center;margin-right:3rem;}> div:focus{outline:0;}> div > label{position:relative;display:inline-flex;align-items:center;margin-bottom:0;color:', ';text-transform:none;> span:last-child{display:inline-block;margin-left:1rem;}}'], bgColorFn, _styles2.default.textColor);

var HoverIcon = (0, _styledComponents2.default)(_SvgIcon2.default).withConfig({
  displayName: 'styled__HoverIcon'
})(['position:absolute;right:3rem;display:flex;flex-direction:column;justify-content:center;opacity:0;transition:opacity 0.3s;svg{width:1rem;height:1rem;fill:', ';}'], _styles2.default.grayLight);
// eslint-disable-next-line react/prop-types
var Pencil = exports.Pencil = function Pencil(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  return _react2.default.createElement(HoverIcon, { className: 'hoverIcon ' + className, name: 'pencil-2' });
};
// eslint-disable-next-line react/prop-types
var DownTriangle = exports.DownTriangle = function DownTriangle(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === undefined ? '' : _ref2$className;
  return _react2.default.createElement(HoverIcon, {
    className: 'hoverIcon ' + className,
    name: 'down-2',
    style: { opacity: 1 }
  });
};

var Select = exports.Select = _styledComponents2.default.select.withConfig({
  displayName: 'styled__Select'
})(['', ' appearance:none;', ' background-image:none;border:none;border-radius:0;box-shadow:none;cursor:pointer;&:focus{outline:0;}&:disabled{cursor:not-allowed;}'], sharedInputStyles, function (p) {
  if (p.value === p.placeholder) {
    return '\n        color: ' + placeholderColor + ';\n      ';
  }
  return '\n      color: ' + _styles2.default.textColor + ';\n    ';
});

var Radio = exports.Radio = _styledComponents2.default.div.withConfig({
  displayName: 'styled__Radio'
})(['display:', ';background-color:', ';height:', ';margin-top:0.5rem;'], function (p) {
  return p.display || 'flex';
}, bgColorFn, function (p) {
  return p.rows ? '' : '100%';
});

var RadioLabel = exports.RadioLabel = (0, _styledComponents2.default)(Label).withConfig({
  displayName: 'styled__RadioLabel'
})(['display:', ';margin-right:2rem;padding:0.5rem 0 0.5rem 1px;width:auto;line-height:', ';', ' span{margin:0 1rem;font-size:', ';font-weight:', ';text-transform:none;}&:before{position:relative;top:0.25rem;left:0;content:\'\';border:1px solid ', ';border-radius:100%;background-color:', ';display:block;box-sizing:border-box;float:left;width:2rem;height:2rem;', '}input[type=\'radio\']{position:absolute;top:auto;overflow:hidden;clip:rect(1px,1px,1px,1px);width:1px;height:1px;white-space:nowrap;}'], function (p) {
  return p.display || 'inline';
}, lineHeightFn, function (p) {
  return p.disabled && (0, _styledComponents.css)(['pointer-events:none;']);
}, _styles2.default.inputTextSm, _styles2.default.fontWeightNormal, getRadioBorderColor, _styles.colors.white, function (p) {
  return p.checked && (0, _styledComponents.css)(['background-color:', ';border:none;box-shadow:inset 0 0 0 0.75rem ', ';'], _styles.colors.white, getRadioBackgroundColor);
});
var DisabledWrapper = exports.DisabledWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'styled__DisabledWrapper'
})(['cursor:', ';'], function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
});


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Field/styled.js
// module id = 219
// module chunks = 14